import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { SimpleHero } from 'components/SimpleHero';
import { pick } from 'helpers/object';

export class Template extends PureComponent {
  renderCta() {
    const { ctaCopy, ctaLink, openInNewTab } = this.props;

    if (!ctaCopy) {
      return false;
    }

    const linkIsFullyQualified = ctaLink && ctaLink.indexOf('http') === 0;
    const useAnchor = linkIsFullyQualified || openInNewTab;

    let cta;

    if (useAnchor) {
      cta = (
        <a href={ctaLink} className="bt bt--primary bt--lg" {...(openInNewTab ? { target: '_blank' } : {})}>
          {ctaCopy}
        </a>
      );
    } else {
      cta = (
        <Link to={ctaLink} className="bt bt--primary bt--lg">
          {ctaCopy}
        </Link>
      );
    }

    return <div className="pt--">{cta}</div>;
  }

  render() {
    const passthroughProps = pick(
      ['backgroundColor', 'body', 'children', 'footer', 'imageAlignment', 'imageAlt', 'imageUrl', 'title', 'titleSize'],
      this.props
    );

    return <SimpleHero {...passthroughProps} cta={this.renderCta()} />;
  }
}

Template.propMapper = (state, moduleDef) => ({
  title: moduleDef.title,
  titleSize: moduleDef.titleSize,
  backgroundColor: moduleDef.backgroundColor || 'white',
  body: moduleDef.body,
  footer: moduleDef.footer,
  imageAlignment: moduleDef.imageAlignment,
  imageUrl: moduleDef.image && moduleDef.image.image,
  imageAlt: moduleDef.image && moduleDef.image.altText,
  ctaCopy: moduleDef.cta && moduleDef.cta.title,
  ctaLink: moduleDef.cta && moduleDef.cta.url,
  openInNewTab: moduleDef.openInNewTab,
  eventName: moduleDef.eventName,
  eventLabel: moduleDef.eventLabel,
});

Template.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  backgroundColor: PropTypes.oneOf(['light', 'white']),
  footer: PropTypes.string,

  imageAlignment: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,

  ctaCopy: PropTypes.string,
  ctaLink: PropTypes.string,
  openInNewTab: PropTypes.bool,

  eventName: PropTypes.string,
  eventLabel: PropTypes.string,

  children: PropTypes.node,
};
